module.exports = __webpack_public_path__ + "static/media/A7S01906.e01e52d1.jpg";